import { getAuthHeaders } from './api';

const API_URL = process.env.REACT_APP_API_URL || '/api';

class Logger {
  constructor() {
    this.currentUser = null;
  }

  setUser(user) {
    this.currentUser = user;
  }

  async log(level, message, metadata = {}) {
    try {
      // Get current user info from our stored user
      let userInfo = { email: 'anonymous', sub: 'anonymous' };
      if (this.currentUser?.email) {
        userInfo = {
          email: this.currentUser.email,
          sub: this.currentUser.sub
        };
      }

      // Get auth headers
      let headers = {
        'Content-Type': 'application/json'
      };
      try {
        headers = await getAuthHeaders();
      } catch (e) {
        // If not authenticated, proceed with basic headers
      }

      const response = await fetch(`${API_URL}/log`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          level,
          message,
          metadata: {
            ...metadata,
            user: userInfo,
            component: metadata.component || 'unknown',
            timestamp: new Date().toISOString()
          }
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Failed to send log to server:', errorText);
      }
    } catch (error) {
      console.error('Error sending log to server:', error);
    }
  }

  error(message, metadata = {}) {
    return this.log('error', message, metadata);
  }

  warn(message, metadata = {}) {
    return this.log('warn', message, metadata);
  }

  info(message, metadata = {}) {
    return this.log('info', message, metadata);
  }

  debug(message, metadata = {}) {
    return this.log('debug', message, metadata);
  }
}

export default new Logger();
